export const customerreportdata = [
  {
    id:"1",
    Reference: "INV2025",
    Code: "CU001",
    Customer: "Carl Evans",
    image: "assets/img/users/user-32.jpg",
    Total_Orders: 10,
    Amount: "$1000",
    Payment_Method: "Cash",
    Status: "Completed",
  },
  {
    id:"2",
    Reference: "INV2031",
    Code: "CU002",
    Customer: "Minerva Rameriz",
    image: "assets/img/users/user-02.jpg",
    Total_Orders: 15,
    Amount: "$1500",
    Payment_Method: "Paypal",
    Status: "Completed",
  },
  {
    id:"3",
    Reference: "INV2042",
    Code: "CU003",
    Customer: "Robert Lamon",
    image: "assets/img/users/user-01.jpg",
    Total_Orders: 22,
    Amount: "$1500",
    Payment_Method: "Paypal",
    Status: "Completed",
  },
  {
    id:"4",
    Reference: "INV2033",
    Code: "CU004",
    Customer: "Patricia Lewis",
    image: "assets/img/users/user-04.jpg",
    Total_Orders: 14,
    Amount: "$2000",
    Payment_Method: "Stripe",
    Status: "Completed",
  },
  {
    id:"5",
    Reference: "INV2042",
    Code: "CU005",
    Customer: "Mark Joslyn",
    image: "assets/img/users/user-08.jpg",
    Total_Orders: 12,
    Amount: "$800",
    Payment_Method: "Paypal",
    Status: "Completed",
  },
  {
    id:"6",
    Reference: "INV2011",
    Code: "CU006",
    Customer: "Marsha Betts",
    image: "assets/img/users/user-10.jpg",
    Total_Orders: 45,
    Amount: "$750",
    Payment_Method: "Cash",
    Status: "Completed",
  },
  {
    id:"7",
    Reference: "INV2014",
    Code: "CU007",
    Customer: "Daniel Jude",
    image: "assets/img/users/user-28.jpg",
    Total_Orders: 21,
    Amount: "$1300",
    Payment_Method: "Credit Card",
    Status: "Completed",
  },
  {
    id:"8",
    Reference: "INV2056",
    Code: "CU008",
    Customer: "Emma Bates",
    image: "assets/img/users/user-17.jpg",
    Total_Orders: 78,
    Amount: "$1100",
    Payment_Method: "Stripe",
    Status: "Completed",
  },
  {
    id:"9",
    Reference: "INV2047",
    Code: "CU009",
    Customer: "Richard Fralick",
    image: "assets/img/users/user-20.jpg",
    Total_Orders: 15,
    Amount: "$1700",
    Payment_Method: "Credit Card",
    Status: "Completed",
  },

];
export const customerduereportdata = [
  {
    id:"1",
    Reference: "INV2025",
    Code: "CU001",
    Customer: "Carl Evans",
    image: "assets/img/users/user-32.jpg",
    Total_Orders: 10,
    Amount: "$1000",
    Payment_Method: "Cash",
    Status: "Paid",
  },
  {
    id:"2",
    Reference: "INV2031",
    Code: "CU002",
    Customer: "Minerva Rameriz",
    image: "assets/img/users/user-02.jpg",
    Total_Orders: 15,
    Amount: "$1500",
    Payment_Method: "Paypal",
    Status: "Paid",
  },
  {
    id:"3",
    Reference: "INV2042",
    Code: "CU003",
    Customer: "Robert Lamon",
    image: "assets/img/users/user-01.jpg",
    Total_Orders: 22,
    Amount: "$1500",
    Payment_Method: "Paypal",
    Status: "Paid",
  },
  {
    id:"4",
    Reference: "INV2033",
    Code: "CU004",
    Customer: "Patricia Lewis",
    image: "assets/img/users/user-04.jpg",
    Total_Orders: 14,
    Amount: "$2000",
    Payment_Method: "Stripe",
    Status: "Paid",
  },
  {
    id:"5",
    Reference: "INV2042",
    Code: "CU005",
    Customer: "Mark Joslyn",
    image: "assets/img/users/user-08.jpg",
    Total_Orders: 12,
    Amount: "$800",
    Payment_Method: "Paypal",
    Status: "Paid",
  },
  {
    id:"6",
    Reference: "INV2011",
    Code: "CU006",
    Customer: "Marsha Betts",
    image: "assets/img/users/user-10.jpg",
    Total_Orders: 45,
    Amount: "$750",
    Payment_Method: "Cash",
    Status: "Paid",
  },
  {
    id:"7",
    Reference: "INV2014",
    Code: "CU007",
    Customer: "Daniel Jude",
    image: "assets/img/users/user-28.jpg",
    Total_Orders: 21,
    Amount: "$1300",
    Payment_Method: "Credit Card",
    Status: "Overdue",
  },
  {
    id:"8",
    Reference: "INV2056",
    Code: "CU008",
    Customer: "Emma Bates",
    image: "assets/img/users/user-17.jpg",
    Total_Orders: 78,
    Amount: "$1100",
    Payment_Method: "Stripe",
    Status: "Paid",
  },
  {
    id:"9",
    Reference: "INV2047",
    Code: "CU009",
    Customer: "Richard Fralick",
    image: "assets/img/users/user-20.jpg",
    Total_Orders: 15,
    Amount: "$1700",
    Payment_Method: "Credit Card",
    Status: "Unpaid",
  },

];
